import axios from "axios";



const access_token = null || localStorage.getItem("access_token");


const  all ={
async attributsByPerimetre(data) {
  const response = await axios.post(`${process.env.REACT_APP_ADMIN_API_URL}/api/attribut/list/byPerimetre`, data, 
  {
    headers: {
    "Content-type": "application/json",
    Authorization: `${access_token}`,
  },
  withCredentials: false,
  });
  console.log('get data attrb perim service=',response)
  return response.data;
},
async getAttributsByGrid (gridId) {
  return await axios.get(`${process.env.REACT_APP_API_BASE_URL}/attributsGrids/${gridId}`).then((response) => { 
    return response.data;
  });
}
}
export default all ;